import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      content: "Dzięki Jasnym Grantom udało nam się pozyskać 2 miliony złotych na rozwój naszej organizacji. Profesjonalizm i zaangażowanie zespołu były kluczowe dla naszego sukcesu.",
      author: "Anna Kowalska",
      position: "Prezes Fundacji EkoMiejsce",
      initials: "AK"
    },
    {
      content: "Współpraca z Jasne Granty przekroczyła nasze oczekiwania. Nie tylko napisali wygrywający wniosek, ale też wspierali nas przez cały okres realizacji projektu.",
      author: "Marek Nowak",
      position: "Burmistrz Miasta Przykładów",
      initials: "MN"
    },
    {
      content: "Dzięki profesjonalnemu biznesplanowi przygotowanemu przez Jasne Granty, udało nam się pozyskać inwestora strategicznego. Polecamy każdemu przedsiębiorcy!",
      author: "Ewa Wiśniewska",
      position: "CEO TechStart Sp. z o.o.",
      initials: "EW"
    }
  ];

  return (
    <section id="testimonials" className="testimonials">
      <div className="container">
        <div className="section-header">
          <div className="section-subtitle">Opinie klientów</div>
          <h2>Co Mówią o Nas Nasi Klienci?</h2>
          <p>
            Zadowolenie klientów jest dla nas najważniejsze. 
            Zobacz, co mówią o współpracy z nami.
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-content">
                "{testimonial.content}"
              </div>
              <div className="testimonial-author">
                <div className="author-avatar">
                  {testimonial.initials}
                </div>
                <div className="author-info">
                  <h5>{testimonial.author}</h5>
                  <p>{testimonial.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
